(function () {
  if (customElements.get('byteex-pdp-adult-upload')) return;

  var STORAGE_KEY = 'uploadedImageAdult';
  var COMPRESS_MAX = 2000;
  var COMPRESS_QUALITY = 0.7;

  function compressImage(src) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.onload = function () {
        var w = img.width;
        var h = img.height;
        if (w > COMPRESS_MAX || h > COMPRESS_MAX) {
          if (w > h) {
            h = Math.round((h * COMPRESS_MAX) / w);
            w = COMPRESS_MAX;
          } else {
            w = Math.round((w * COMPRESS_MAX) / h);
            h = COMPRESS_MAX;
          }
        }
        var canvas = document.createElement('canvas');
        canvas.width = w;
        canvas.height = h;
        canvas.getContext('2d').drawImage(img, 0, 0, w, h);
        resolve(canvas.toDataURL('image/jpeg', COMPRESS_QUALITY));
      };
      img.onerror = reject;
      img.src = src;
    });
  }

  customElements.define(
    'byteex-pdp-adult-upload',
    class ByteexPdpAdultUpload extends HTMLElement {
      connectedCallback() {
        this.uploadStep = this.querySelector('[data-byteex-adult-step="upload"]');
        this.previewStep = this.querySelector('[data-byteex-adult-step="preview"]');
        this.thumb = this.querySelector('[data-byteex-adult-thumb]');
        this.fileInputs = Array.prototype.slice.call(
          this.querySelectorAll('[data-byteex-adult-input]')
        );

        this._onFileChange = this._onFileChange.bind(this);

        this.fileInputs.forEach(function (input) {
          input.addEventListener('change', this._onFileChange);
        }, this);

        this._restoreFromStorage();
      }

      disconnectedCallback() {
        if (this.fileInputs) {
          this.fileInputs.forEach(function (input) {
            input.removeEventListener('change', this._onFileChange);
          }, this);
        }
      }

      _restoreFromStorage() {
        var stored = null;
        try {
          stored = localStorage.getItem(STORAGE_KEY);
        } catch (err) {
          return;
        }
        if (stored) this._showPreview(stored);
      }

      _onFileChange(event) {
        var input = event.target;
        var file = input.files && input.files[0];
        input.value = '';
        if (!file || !file.type || file.type.indexOf('image') !== 0) return;

        var reader = new FileReader();
        var self = this;
        reader.onload = function (e) {
          compressImage(e.target.result)
            .then(function (compressed) {
              try {
                localStorage.setItem(STORAGE_KEY, compressed);
              } catch (err) {
                /* quota exceeded or storage disabled — preview still works for the session */
              }
              self._showPreview(compressed);
              self.dispatchEvent(new CustomEvent('byteex-adult-image-ready', {
                bubbles: true,
                detail: { dataUrl: compressed }
              }));
            })
            .catch(function () {
              /* compression failed — silently ignore, leave UI in current state */
            });
        };
        reader.readAsDataURL(file);
      }

      _showPreview(dataUrl) {
        if (this.thumb) this.thumb.src = dataUrl;
        if (this.uploadStep) this.uploadStep.style.display = 'none';
        if (this.previewStep) this.previewStep.style.display = '';
      }
    }
  );
})();

(function () {
  function syncGroup(name) {
    var radios = document.querySelectorAll(
      '.byteex-pdp-gender-option input[type="radio"][name="' + name + '"]'
    );
    radios.forEach(function (radio) {
      var option = radio.closest('.byteex-pdp-gender-option');
      if (option) {
        option.classList.toggle('byteex-pdp-gender-option--checked', radio.checked);
      }
    });
  }

  function init() {
    var radios = document.querySelectorAll('.byteex-pdp-gender-option input[type="radio"]');
    if (!radios.length) return;
    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        syncGroup(radio.name);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
